import { intlReducer } from 'react-intl-redux';
import { reducers as schibstedAccountReducers } from './schibstedAccount';
import { reducer as configReducer } from './config';
import { reducer as subscriptionReducer } from './subscription';
import { reducer as authenticationReducer } from './authentication';
import { reducer as modalsReducer } from './modals';
import { reducer as snackbarReducer } from './snackbar';
/* PLOP_INJECT_REDUCER_IMPORT */
import { SWITCH_DEVICE, SET_DEBUG_MODE } from './types';

export const { spid } = schibstedAccountReducers;
// noinspection JSUnusedGlobalSymbols
// todo export customized reducers and middlewares per publication

export {
    configReducer as config,
    subscriptionReducer as subscription,
    authenticationReducer as login,
    intlReducer as intl,
    modalsReducer as modals,
    snackbarReducer as snackbar,
    /* PLOP_INJECT_REDUCER_EXPORT */
};

const detectedDevice = window.navigator.userAgent.includes('_app_') ? 'mobile-app' : 'desktop';

export const device = (state = detectedDevice, action) => {
    if (action.type === SWITCH_DEVICE) {
        return action.payload;
    }

    return state;
};

export const debug = (state = window.navigator.userAgent.includes('_debug_'), action) => {
    if (action.type === SET_DEBUG_MODE) {
        return action.payload;
    }

    return state;
};
